// Default mall WhatsApp number
export const MALL_WHATSAPP_NUMBER = "19715070777";

/**
 * Opens WhatsApp chat with the mall
 * @param {string} [text] - Optional pre-filled text message
 */
export const openWhatsApp = (text = "") => {
  let url = `https://wa.me/${MALL_WHATSAPP_NUMBER}`;

  if (text && text.trim() !== "") {
    url += `?text=${encodeURIComponent(text)}`;
  }

  window.open(url, "_blank");
};

/**
 * Initiates a phone call to the mall
 */
export const callMall = () => {
  const mallPhoneNumber = MALL_WHATSAPP_NUMBER;
  window.location.href = `tel:+${mallPhoneNumber}`;
};
